import React from "react";
import Button from "../../../../Components/FormElements/Button";
import IconInformation from "../../../../Resources/svg/Icons/IconInformation";

const TextCE = ({data, loadingClick, action, actionSecundary}: any) => {
  return (
    <>
      <div className="thankyou-page__texts">
        <p className="thankyou-page__title">
          ¡La solicitud de cotización Nº COT-{data.numSimulacion} está lista!
        </p>

        <p className="thankyou-page__subtitle">
          Entrega esta solicitud al cliente para que pueda revisarla y firmarla.
        </p>
        <div className="thankyou-page__information">
          <IconInformation />
          Ten en cuenta pedir que los <span>datos del cliente</span> estén
          registrados en <span>SAS.</span>
        </div>
      </div>
      <div className="thankyou-page__actions">
        <Button
          type="button"
          onClick={() => action(data)}
          className={loadingClick ? "is-loading" : ""}
        >
          Descargar solicitud
        </Button>
        <Button
          type="button"
          className="is-secondary"
          onClick={() => actionSecundary()}
        >
          Nueva cotización
        </Button>
      </div>
    </>
  );
};

export default TextCE;
